import { render, staticRenderFns } from "./info-text-element.vue?vue&type=template&id=bcd7ba2c"
import script from "./info-text-element.vue?vue&type=script&lang=js"
export * from "./info-text-element.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports